// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getPageMetadata } from "@insite/client-framework/ServerSideRendering";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { activeStateTrue } from "@steiner/App/Widgets/SearchEngineOptimization/ActiveState";
import { SeoAppProps, SeoHandlerProps } from "@steiner/App/Widgets/SearchEngineOptimization/Type";
import { WebPage, WithContext } from "@steiner/App/Widgets/SearchEngineOptimization/Type/schema";

/**
 * Build the structured data
 */
const loadSchemaWebPage = ({ state, fields, url }: SeoAppProps): WithContext<WebPage> => {
    const metadata = getPageMetadata();
    const location = getLocation(state);
    const pageUrl = `${url}${location.pathname}`;
    const metaDescriptionElement =
        typeof document !== "undefined"
            ? (document.querySelector('meta[name="description"]') as HTMLMetaElement)
            : null;
    const metaDescription = metaDescriptionElement?.content;
    return {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name:
            metadata?.openGraphTitle ||
            (typeof document !== "undefined" ? document.title : "") ||
            fields.organizationName ||
            state.context.website.name,
        description: metadata?.metaDescription || metaDescription,
        url: pageUrl,
    };
};

export default {
    isActivate: activeStateTrue,
    buildSchema: loadSchemaWebPage,
} as SeoHandlerProps;
